// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2rAYQ","log":"ModalInventoryLogs_log__NGSqH","date":"ModalInventoryLogs_date__2ITXd","userName":"ModalInventoryLogs_userName__3e1SY"};